import { jsx } from "react/jsx-runtime";
import { PhoneInputFieldWUT } from "../../../ui/phone-input-field/phone-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsPhoneWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_PHONE;
  return /* @__PURE__ */ jsx(PhoneInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsPhoneWUT
};
//# sourceMappingURL=contacts-phone-wut.js.map
